<template>
  <div id="container">
    <div class="title_wrap">
      <div class="title_wrap">
        <h1 v-if="isEditSaveMode">메뉴수정</h1>
        <h1 v-else>메뉴등록</h1>
      </div>
    </div>

    <form id="menuInfoForm" v-kendo-validator @submit.prevent="">
      <!-- 기본정보 -->
      <div class="contents_wrap">
        <div class="small_title_wrap">
          <h2>마스터정보</h2>
        </div>
        <ul class="filter_list">
          <li>
            <dd>
              <label>솔루션/웹/모바일구분
                <span class="forg">*</span>
              </label>
              <ul>
                <li>
                  <span class="fl w70">
                    <kendo-multicolumncombobox
                      required
                      ref="searchSolCdRef"
                      id="searchSolCd"
                      :data-text-field="'solNm'"
                      :data-value-field="'value'"
                      :data-source="solutionDataArray"
                      @change="onChangeSolutionEvent"
                      v-bind:placeholder="'솔루션을 선택하세요'"
                      validationMessage="솔루션을 선택하세요"
                      :filter="'contains'"
                      style="width:500px">
                      <kendo-multicolumncombobox-column :field="'solNm'"
                                                        :title="'솔루션'"></kendo-multicolumncombobox-column>
                      <kendo-multicolumncombobox-column :field="'wmGbnText'" :title="'구분'"
                                                        :width="120"></kendo-multicolumncombobox-column>
                    </kendo-multicolumncombobox>
                  </span>
                </li>
              </ul>
            </dd>

          </li>
          <li>
            <dd>
              <label>상위메뉴</label>
              <ul>
                <li v-if="isEditSaveMode">{{menuInfo.superMenuNm}}</li>
                <li v-else>
                  <kendo-dropdownlist
                    ref="searchSuperMenuRef"
                    id="searchSuperMenuId"
                    :data-text-field="'menuNm'"
                    :data-value-field="'menuMasterPK.menuId'"
                    :data-source="menuDataArray"
                    @change="onChangeSuperMenu"
                    :option-label="'선택'"
                    style="width:500px">
                  </kendo-dropdownlist>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>메뉴명
                <span class="forg">*</span>
              </label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                    required
                    ref="menuNmRef"
                    id="menuNm"
                    maxlength="500"
                    v-bind:style="'width: 100%;'"
                    v-bind:placeholder="'메뉴명을 입력하세요'"
                    validationMessage="메뉴명을 입력하세요"
                  >
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
            <dd>
              <label>메뉴ID
              </label>
              <ul>
                <li v-if="isEditSaveMode">{{menuInfo.menuId}}</li>
                <li v-else>
                  솔루션코드와 상위메뉴에 따라 자동생성됩니다
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>메뉴URL
              </label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                    ref="urlLinkRef"
                    id="urlLink"
                    maxlength="1000"
                    v-bind:style="'width: 100%;'"
                    v-bind:placeholder="'메뉴URL을 입력하세요'"
                  >
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>조회순서
                <span class="forg">*</span>
              </label>

              <ul>
                <li>
                  <kendo-numerictextbox
                    ref="seqNoRef"
                    name="seqNo"
                    :min="1"
                    :max="40"
                    :format="'n0'"
                    :placeholder="'조회순서를 입력하세요'"
                    :style="'width: 100%;'"
                  >
                  </kendo-numerictextbox>
                </li>
              </ul>
            </dd>
            <dd>
              <label>사용여부
                <span class="forg">*</span>
              </label>
              <ul>
                <li>
                  <kendo-switch ref="useYnRef" v-model="menuUseYn"></kendo-switch>
                </li>
              </ul>
            </dd>
          </li>
        </ul>
      </div>


      <!---추가정보 --->
      <div class="contents_wrap">
        <div class="small_title_wrap">
          <h2>다국어정보</h2>
        </div>
        <ul class="filter_list">
          <li>
            <dd>
              <label>영어
              </label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                    ref="menuEnRef"
                    id="menuEn"
                    v-bind:style="'width: 100%;'"
                    v-bind:placeholder="'영어 메뉴명을 입력하세요'"
                  >
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>중국어
              </label>
              <ul>
                <li>
                  <kendo-maskedtextbox
                    ref="menuZhRef"
                    id="menuZh"
                    v-bind:style="'width: 100%;'"
                    v-bind:placeholder="'중국어 메뉴명을 입력하세요'"
                  >
                  </kendo-maskedtextbox>
                </li>
              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>베트남어
              </label>
              <ul>

                <li>
                  <kendo-maskedtextbox
                    ref="menuVnRef"
                    id="menuVn"
                    v-bind:style="'width: 100%;'"
                    v-bind:placeholder="'베트남어 메뉴명을 입력하세요'"
                  >
                  </kendo-maskedtextbox>
                </li>

              </ul>
            </dd>
          </li>
          <li>
            <dd>
              <label>일본어
              </label>
              <ul>

                <li>
                  <kendo-maskedtextbox
                    ref="menuJpRef"
                    id="menuJp"
                    v-bind:style="'width: 100%;'"
                    v-bind:placeholder="'일본어 메뉴명을 입력하세요'"
                  >
                  </kendo-maskedtextbox>
                </li>

              </ul>
            </dd>
          </li>
        </ul>
      </div>
      <!--- 버튼영역 --->
      <div class="button_area w40">
        <ul>
          <li class="w30">
            <button class="large_btn orange" @click="onClickMenuSave">{{isEditSaveMode?'수정':'등록'}}</button>
          </li>
          <li class="w30">
            <button class="large_btn" @click="onClickGoBack">목록</button>
          </li>
        </ul>
      </div>
    </form>
  </div>
</template>

<script>

  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '@/common/etners.common.util'
  import EtnersKendoGridUtil from '@/common/kendo.grid.util'
  import EtnersParseUtil from '@/common/etners.parse.util'
  import EtnersDateTimeUtil from '@/common/etners.datetime.util'

  export default {
    name: 'AdminMenuSave',
    data: function () {
      const solCd = this.$route.params.solCd;
      const wmGbn = this.$route.params.wmGbn;
      const finalSolutionMap = [];
      const solutionMap = EtnersCommonUtil.getAllSolutionMasterMapUsingVuex();
      const codeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex();
      const menuAllDataMap = EtnersCommonUtil.getAllMenuMasterMapUsingVuex();

      for (const key in solutionMap) {
        const keyMap = solutionMap[key];
        for (const keyMapArray in keyMap) {

          keyMap[keyMapArray].value = `${keyMap[keyMapArray].solCd}_${keyMap[keyMapArray].wmGbn}`;
          keyMap[keyMapArray].wmGbnText = EtnersParseUtil.commonCodeToText(codeMap, `102_${keyMap[keyMapArray].wmGbn}`);

          finalSolutionMap.push(keyMap[keyMapArray])
        }

      }


      const filterMenuBySolCd = menuAllDataMap.filter(menuData => {
        return menuData.menuMasterPK.solCd === solCd && menuData.menuMasterPK.wmGbn === wmGbn && menuData.menuDepth === "1"
      });

      return {
        solCd: '',
        wbGbn: '',
        menuId: '',
        superMenuId: '',
        isEditSaveMode: false,
        menuInfo: {},
        menuUseYn: false,
        solutionDataArray: finalSolutionMap,
        menuDataArray: filterMenuBySolCd
      }
    },
    created() {
      this.solCd = this.$route.params.solCd;
      this.wmGbn = this.$route.params.wmGbn;
      this.menuId = this.$route.params.menuId;
      // 수정모드 여부 저장
      this.isEditSaveMode = this.solCd !== undefined && this.solCd !== '' && this.wmGbn !== undefined && this.wmGbn !== '' && this.menuId !== undefined && this.menuId !== '';
    },
    mounted: function () {

      if (this.isEditSaveMode) {
        this.getMenuDetail(this.solCd, this.wmGbn, this.menuId)
      }
    },
    updated: function () {
      // 크롬에서 css가 안먹는 현상 임시 수정.
      // 정확한 원인은 파악되지 않았지만 vuex에서 commit을 사용하면
      // k-maskedtextbox 클래스가 먹은 span 태그에 k-textbox 클래스가 추가되면서 css가 어그러지는 현상을 발견함.
      const removeKTextBoxClass = function (count) {
        let inputElements = document.getElementsByClassName('k-widget k-maskedtextbox k-textbox');

        if (inputElements.length > 0 || count > 0) {
          try {
            for (let i = 0; i < inputElements.length; i++) {
              let element = inputElements[i];

              element.classList.remove('k-textbox')
            }
          } catch (e) {
          }

          setTimeout(function () {
            count--;

            removeKTextBoxClass(count)
          }, 20)
        }
      };

      removeKTextBoxClass(10)
    },
    methods: {
      onChangeSuperMenu(ev) {

        this.superMenuId = ev.sender.value()
      },
      onChangeSolutionEvent(ev) {
        const vm = this;
        const value = ev.sender.value().split('_');
        let menuAllDataMap = EtnersCommonUtil.getAllMenuMasterMapUsingVuex()
        if (value.length > 1) {
          const solCd = value[0];
          const wmGbn = value[1];
          vm.solCd = solCd
          vm.wmGbn = wmGbn
          const filterMenuBySolCd = menuAllDataMap.filter(menuData => {
            return menuData.menuMasterPK.solCd === solCd && menuData.menuMasterPK.wmGbn === wmGbn && menuData.menuDepth === "1"
          });

          setTimeout(function () {
            vm.menuDataArray = filterMenuBySolCd
          }, 100)

        }
      },
      getMenuDetail(solCd, wmGbn, menuId) {

        const vm = this;
        const loginUserToken = sessionStorage.lutk;

        let param = {
          loginUserToken: loginUserToken,
          solCd: solCd,
          wmGbn: wmGbn,
          menuId: menuId
        };
        ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/menu/detail.json`, param).then(function (response) {
            if (response.data.resultStatus.messageCode === '2000') {
              let changeResultData = response.data.resultData;

              vm.menuInfo = changeResultData;

              if (vm.menuInfo != null) {
                vm.menuUseYn = vm.menuInfo.useYn === 'Y'

                vm.$refs.menuNmRef.kendoWidget().value(vm.menuInfo.menuNm)
                vm.$refs.urlLinkRef.kendoWidget().value(vm.menuInfo.urlLink)
                vm.$refs.seqNoRef.kendoWidget().value(vm.menuInfo.seqNo)
                vm.$refs.menuEnRef.kendoWidget().value(vm.menuInfo.menuEn)
                vm.$refs.menuZhRef.kendoWidget().value(vm.menuInfo.menuZh)
                vm.$refs.menuVnRef.kendoWidget().value(vm.menuInfo.menuVn)
                vm.$refs.menuJpRef.kendoWidget().value(vm.menuInfo.menuJp)
                vm.$refs.searchSolCdRef.kendoWidget().value(`${vm.menuInfo.solCd}_${vm.menuInfo.wmGbn}`)
                if (vm.menuInfo.superMenuId !== null) {
                  vm.$refs.searchSuperMenuRef.kendoWidget().value(vm.menuInfo.superMenuId)
                }
                if (!vm.isEditSaveMode) {
                  vm.$refs.menuIdRef.kendoWidget().value(vm.menuInfo.menuId)
                }

              }

            } else {
              kendo.alert(response.data.resultStatus.messageText)
            }
          },
        )
      },
      onClickMenuSave: function () {

        const vm = this
        const refs = vm.$refs
        let validator = vm.kendoValidator
        let confirmKeyword = (vm.isEditSaveMode ? '수정' : '등록')
        if (validator.validate()) {


          kendo.confirm('메뉴 정보를 ' + confirmKeyword + '하시겠습니까?').done(function () {

            // 파라미터 객체 생성
            let param = {
              loginUserToken: sessionStorage.lutk,
              solCd: vm.isEditSaveMode ? vm.menuInfo.solCd : vm.solCd,
              wmGbn: vm.isEditSaveMode ? vm.menuInfo.wmGbn : vm.wmGbn,
              menuId: vm.isEditSaveMode ? vm.menuInfo.menuId : '',
              menuNm: refs.menuNmRef.kendoWidget().value(),
              menuDepth: vm.isEditSaveMode ? vm.menuInfo.menuDepth : refs.searchSuperMenuRef.kendoWidget().value() === '' ? 1 : 2,
              urlLink: refs.urlLinkRef.kendoWidget().value(),
              superMenuId: vm.isEditSaveMode ? vm.menuInfo.superMenuId : vm.superMenuId,
              seqNo: refs.seqNoRef.kendoWidget().value(),
              useYn: refs.useYnRef.kendoWidget().value() ? 'Y' : 'N',
              menuEn: refs.menuEnRef.kendoWidget().value(),
              menuZh: refs.menuZhRef.kendoWidget().value(),
              menuVn: refs.menuVnRef.kendoWidget().value(),
              menuJp: refs.menuJpRef.kendoWidget().value()
            }


            vm.$Progress.start()
            ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/menu/upsert.json`, param).then(response => {
              if (response.data === undefined || response.data.resultStatus === undefined) {
                kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
                vm.$Progress.fail()
                return false

              }
              if (response.data.resultStatus.messageCode !== '2000') {
                kendo.alert(response.data.resultStatus.messageText)
                vm.$Progress.fail()
                return false
              }

              kendo.alert(confirmKeyword + '되었습니다.')
              sessionStorage.removeItem('__VUEX_ALL_MENU_MAP__')
              // progressbar 종료
              vm.$Progress.finish()

              let responseSolCd = response.data.resultData.solCd
              let responseWmGbn = response.data.resultData.wmGbn
              let responseMenuId = response.data.resultData.menuId
              if (responseSolCd !== undefined && responseSolCd !== '' && responseWmGbn !== undefined && responseWmGbn !== ''
                && responseMenuId !== undefined && responseMenuId !== '') {
                // 상세 화면으로
                vm.onClickGoDetail(responseSolCd, responseWmGbn, responseMenuId)
              } else {
                vm.onClickGoBack()
              }
            })

          })
        } else {
          let errors = validator.errors()
          kendo.alert(errors[0])
        }

      },
      // 상세 화면으로 이동 (등록/수정 후)
      onClickGoDetail: function (solCd, wmGbn, menuId) {
        this.$router.push({
          name: 'AdminMenuDetail',
          params: {
            solCd: solCd,
            wmGbn: wmGbn,
            menuId: menuId
          },
        })
      },
      onClickGoBack: function () {

        this.$router.push({name: 'AdminMenu'})

      },
    },
  }
</script>

<style scoped>
</style>

